import {
  access,
  integrationStatus 
} from '@driftt/traffic-control'

export const PardotAccessTypes = {
  HAS_ACCESS_NOT_CONNECTED: 'HAS_ACCESS_NOT_CONNECTED',
  HAS_ACCESS_CONNECTED: 'HAS_ACCESS_CONNECTED',
  NO_ACCESS: 'NO_ACCESS',
}

const hasGate = (gate) => {
  return access.hasGates(gate)
}

const hasPremiumOrEnterprisePlan = () => {
  return hasGate('premium_enterprise')
}

export const shouldShowPardotImports = () => {
  return hasPremiumOrEnterprisePlan() || hasGate('HAS_PARDOT_SYNC_LIST')
}

export const getOrgPardotAccessType = () => {
  const hasAccess = shouldShowPardotImports()
  const pardotIsConnected = integrationStatus.isIntegrationConnected('pardot')

  if (hasAccess && pardotIsConnected) {
    return PardotAccessTypes.HAS_ACCESS_CONNECTED
  }

  if (hasAccess && !pardotIsConnected) {
    return PardotAccessTypes.HAS_ACCESS_NOT_CONNECTED
  }

  return PardotAccessTypes.NO_ACCESS
}
